import * as types from '../constants';
import { getKey } from '../helpers'

const mergeValuesById = (currentValues = [], nextValues = []) => {
  const merged = new Map();

  currentValues.forEach((value) => {
    if (value?.id !== undefined && value?.id !== null) {
      merged.set(String(value.id), value);
    }
  });

  nextValues.forEach((value) => {
    if (value?.id !== undefined && value?.id !== null) {
      merged.set(String(value.id), value);
    }
  });

  return Array.from(merged.values());
};

export default function reducer(state={}, {type, payload = {}}) {
  const { model, values, error, loadingMore } = payload;
  const key = getKey(payload.itemsListId, model)

  switch (type) {

    case types.LOAD_ITEMS:
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: true,
          loadingMore: false,
          values: state[key]?.values || []
        }
      };

    case types.LOAD_ITEMS_DONE:
      return {
        ...state,
        [key]: {
          loading: false,
          loadingMore: false,
          ...values
        }
      };

    case types.LOAD_ITEMS_LOADING_MORE:
      return {
        ...state,
        [key]: {
          ...state[key],
          loadingMore: Boolean(loadingMore),
        }
      };

    case types.LOAD_ITEMS_APPEND:
      return {
        ...state,
        [key]: {
          ...state[key],
          loading: false,
          loadingMore: false,
          values: mergeValuesById(state[key]?.values, values),
        }
      };

    case types.LOAD_ITEMS_FAILED:
      return {
        ...state,
        [key]: {
          loading: false,
          loadingMore: false,
          values: state[key]?.values || [],
          error
        }
      };

    default:
      return state
  }
}
